import * as React from "react";
import { useState, useEffect } from "react";
import { Button, Dialog, DialogActions, DialogBody, DialogContent, DialogSurface, DialogTitle, DialogTrigger, TagGroup, Tag, InteractionTag,
  Input, InputProps, Label, makeStyles, Text, tokens, MessageBar, MessageBarBody, MessageBarTitle, Spinner, 
  TagGroupProps,TagAppearance,
  InteractionTagPrimary,
  InteractionTagSecondary,
  Badge} from "@fluentui/react-components";
import { getBestOffers, makeOffer } from "../services/AuctionService";
import { IBestOffer } from "../models/offer";
import { IProfile } from "../models/profile";
import { format } from "date-fns";
import { ShoppingBagRegular, StarRegular } from "@fluentui/react-icons";
import { useNavigate } from "react-router-dom";

export interface IHomeProps {
    user: IProfile;
}

export const Home = (props: IHomeProps) => {
  const [bestOffers, setBestOffers] = useState<IBestOffer[]>([]);
  const [bestFilteredOffers, setBestFilteredOffers] = useState<IBestOffer[]>([]);
  const [open, setOpen] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const [bestOffer, setBestOffer] = useState<IBestOffer>();
  const [error, setError] = useState('');
  const [price, setPrice] = useState('0');
  const [lastUpdate, setLastUpdate] = useState(new Date());
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const { user } = props;

  useEffect(() => {
    setLoading(true);
      const fetchData = async (): Promise<void> => {
      console.log(lastUpdate);
      const result = await getBestOffers();
      console.log(result);
      setBestOffers(result);
      setBestFilteredOffers(result);
      // setTimeout(async () => {
      //   setLastUpdate(new Date());
      //   setLoading(true);
      //   const result = await getBestOffers();        
      //   setBestOffers(result);
      //   setLoading(false);
      // }, 10000);
    };
    fetchData()
      .catch(console.error)
      .finally(() => setLoading(false));
  }, [lastUpdate]);

  const OpenDialog = (offer: IBestOffer) => {
    console.log(offer);
    setBestOffer(offer);
    const p = offer.OfferID != "0" ? parseInt(offer.Price?.toString() ?? "29") + 1 : 30;
    setPrice(p.toString());
    setOpen(true);
  }

  const DoOffer = async () => {  
    if(bestOffer){

      if(price == '')  {
        setError('La base d\'asta è 30 €');
        setPrice('30');
        return;
      }
      const priceval = parseInt(price);
      if(priceval < 30)  {
        setError('La base d\'asta è 30 €');
        setPrice('30');
        return;
      }
      if(bestOffer?.Price && priceval <= parseInt(bestOffer.Price) && bestOffer.OfferID != "0")  {
        setError('L\'importo deve essere maggiore della miglior offerta attuale.');
        setPrice(parseInt(bestOffer.Price)+1+'');
        return;
      }
      setError('');
      setLoading(true);
      const res = await makeOffer(bestOffer, parseInt(price));
      setLoading(false);
      console.log(res);
      if (res.Success) {
        console.log("offer submitted: " + price);
        setBestOffer(undefined);
        setPrice("0");
        setOpen(false);
        setError('');
        setLastUpdate(new Date());
      } else {
        if (res.Message === '401') {
          setOpen(false);
          localStorage.removeItem("token");
          localStorage.removeItem("account");
          alert('Sessione scaduta. Effettua il login per continuare.');
          navigate("/login");
        }
        console.log("offer NOT submitted: " + price);
        console.log(res.Message);
        setError(res.Message);
      }      
    }
  };

  const onChange: InputProps["onChange"] = (ev, data) => {
    //if (data.value != '') {      
      setPrice(data.value);
    //}
  };

  const initialTags = [
    { value: "1", children: "HC Milano", selected: true, bgcolor:"#0f6cbd", color:"white" },
    { value: "2", children: "Diavoli Vicenza", selected: true, bgcolor:"#ffa8c1", color:"black"},
    { value: "3", children: "HC Milano W", selected: true, bgcolor:"#ffa8c1", color:"black"},
  ];
  const [visibleTags, setVisibleTags] = React.useState(initialTags);
  const teamfilter = (index: number) => {
    const b = visibleTags.map((item, i) => (i === index ? {...item, selected: !item.selected} : item));
    let a = bestOffers;
    console.log(a.length);
    console.log(b);
    b.forEach((tag, i) => {
      if (tag.selected === false) {
        a = a.filter((offer) => offer.Team !== tag.children);
      }
      console.log(tag.children, a.length);
    });
    console.log(a);
    setBestFilteredOffers(a);
    // visibleTags[index].selected = !visibleTags[index].selected;
    // setVisibleTags(visibleTags);
    console.log("test", index);
    setVisibleTags(b);
  };

  return (
    <div className="container">
      <img src={`${process.env.PUBLIC_URL}/img/banner_inpistaconilcuore_1280.jpg`} style={{ maxWidth: "100%" }} />
      <div className="page-title mb-3">ASTE</div>
      {user.userid == 0 && 
        <MessageBar key="info" intent="info">
          <MessageBarBody>
            <MessageBarTitle><a href="/login">Accedi</a></MessageBarTitle> con il tuo utente per fare la tua offerta.
          </MessageBarBody>
        </MessageBar>
      }
      { 
        !loading && <>
        <div className="mt-3 mb-3">Ultimo aggiornamento: {format(lastUpdate, "dd/MM/yyyy HH:mm:ss")}</div>
        <div className="formButtonRow mb-3">
            {visibleTags.map((tag, index) => (
            <Button key={tag.value} onClick={() =>teamfilter(index)}
              style={{ color: tag.color, backgroundColor: tag.selected ? tag.bgcolor : "#808080"}}>
              {tag.children}
            </Button>
          ))}
        </div> 
        {
          bestFilteredOffers.map((offer: IBestOffer) => {
            return (
              <div key={offer.AuctionID} className="row">
                <div className="col-2 team">
                  <img src={`${process.env.PUBLIC_URL}/img/${offer.Team}.png`} style={{ width: "30px" }} />
                  <div className=" jersey">{offer.JerseyNumber!.padStart(2, '0')}</div>
                </div>                
                <div className="col-6 fullname" style={{fontSize:"12pt"}}>{offer.Fullname}</div>
                <div className="col-2 price">{offer.UserID == '0' ? '' : `${offer.Price} €`}</div>
                {user.userid !== 0 && <div className="col-2 listaoffri" onClick={() => OpenDialog(offer)} >
                  <Badge size="large" icon={<ShoppingBagRegular />} style={{backgroundColor: `${user.userid}`==`${offer.UserID}` ? "#c1a405" : "#0f6cbd"}} />
                </div>}
              </div>
            )})
        }             
        
        {/* <table className="table table-sm" style={{marginBottom:"50px"}} >
          <thead>
            <tr>
              <th scope="col">#</th>
              <th scope="col">Squadra</th>
              <th scope="col">Nome</th>
              <th scope="col">Offerente</th>
              <th scope="col">Offerta</th>
              {user.userid !== 0 ? <th></th> :null}            
            </tr>
          </thead>
          <tbody>
            { 
              bestFilteredOffers.map((offer: IBestOffer) => {
                return (
                  <tr key={offer.AuctionID} className="offerRow">
                    <td>{offer.JerseyNumber}</td>
                    <td>{offer.Team}</td>
                    <td>{offer.Fullname}</td>
                    <td width={200}>{offer.UserName}</td>
                    <td width={50}>€ {offer.Price}</td>
                    {
                      user.userid !== 0 ? 
                        <td width={120}><Button onClick={() => OpenDialog(offer)} >Fai un'offerta</Button></td> 
                      : null
                    }
                  </tr>
                );
              })
            }
          
          </tbody>
        </table>       */}
      </>
      }
      {
        loading && <div style={{margin: "auto" }}><Spinner labelPosition="after" label="Loading..." /></div>
      }
      {
        user.userid !== 0 ?
          <Dialog open={open} onOpenChange={(event, data) => setOpen(data.open)}>          
            <DialogSurface>
              <DialogBody>
                <DialogTitle>Fai un'offerta</DialogTitle>
                <DialogContent style={{overflowX:'hidden'}}>
                  <div className="row">
                    <div className="col-12">
                      Fai un'offerta per la maglia 
                    </div>
                  </div>
                  <div className="col-12 team">
                    <img src={`${process.env.PUBLIC_URL}/img/${bestOffer?.Team}.png`} style={{ width: "30px" }} />
                    <div className=" jersey">{bestOffer?.JerseyNumber!.padStart(2, '0')}</div>
                    <b>{bestOffer?.Fullname}</b>
                  </div>
                  <div className="row mb-3 mt-3">
                    <div className="col-12">
                      {bestOffer?.OfferID == "0" ? "Non ci sono offerte" : `Miglior offerta attuale ${bestOffer?.Price} €`}
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-12"><Label required htmlFor={"price"}>Importo</Label></div>
                    <div className="col-12"><Input contentAfter={<Text size={400} id="content-before">€</Text>} 
                      required type="number" id={"price"} value={price} onChange={onChange} /></div>
                  </div>                  

                  <div className="formErrorDiv mt-3" style={{minHeight:"50px"}}>
                    {error && <MessageBar key="error" intent="error" layout="multiline">
                      <MessageBarBody>
                        <MessageBarTitle>Errore:</MessageBarTitle>{error}
                      </MessageBarBody>
                    </MessageBar>}
                  </div>


                </DialogContent>
                <DialogActions>
                  <DialogTrigger disableButtonEnhancement>
                    <Button appearance="secondary" onClick={() => setError('')}>Chiudi</Button>
                  </DialogTrigger>
                  {
                    loading && <div style={{margin: "auto" }}><Spinner labelPosition="after" label="Loading..." /></div>
                  }
                  {
                    !loading && <Button appearance="primary" onClick={DoOffer}>Conferma</Button>
                  }   
                </DialogActions>
              </DialogBody>
            </DialogSurface>
          </Dialog>
          : null
      }
    </div>
  );
};